module.exports = __webpack_public_path__ + "img/ap_ac_off.5a2c69f7.png";